import { useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SESSION_KEY = 'rpt_visit_tracked';

/**
 * Privacy-friendly visit tracker.
 * Fires exactly ONCE per browser session, no matter how many pages the
 * visitor opens. Records only timestamp + page path on the backend.
 * No cookies, no third party, no PII.
 */
export default function VisitTracker() {
  useEffect(() => {
    try {
      if (sessionStorage.getItem(SESSION_KEY)) return;
      sessionStorage.setItem(SESSION_KEY, '1');
      axios.post(`${API}/track-visit`, { path: window.location.pathname }).catch(() => {});
    } catch {
      // If sessionStorage is disabled, silently skip — never break the site.
    }
  }, []);
  return null;
}
